import React, { useState, useEffect } from 'react';
import { LockClosedIcon, BookOpenIcon } from '@heroicons/react/24/solid';
import bookCover1 from '../assets/images/book1.png';
import bookCover2 from '../assets/images/book2.png';
import bookCover3 from '../assets/images/book3.png';
import bookCover4 from '../assets/images/book4.png';
import bookCover5 from '../assets/images/book5.png';
import bookCover6 from '../assets/images/book6.png';
import bookCover7 from '../assets/images/book7.png';
// import bookCover8 from '../assets/images/book8.png';
// import bookCover9 from '../assets/images/book9.png';
// import bookCover10 from '../assets/images/book10.png';

// Импорт PDF файлов
import book1 from '../assets/books/1.pdf';
import book2 from '../assets/books/2.pdf';
import book3 from '../assets/books/3.pdf';
import book4 from '../assets/books/4.pdf';
import book5 from '../assets/books/5.pdf';
import book6 from '../assets/books/6.pdf';
import book7 from '../assets/books/7.pdf';

import BottomNav from '../components/mobile/BottomNav';
import { useTranslations } from '../hooks/useTranslations';

function Books() {
  const [userData, setUserData] = useState(null);
  const { t } = useTranslations();

  const books = [
    {
      id: 1,
      title: t('books.forexForBeginners'),
      description: t('books.forexForBeginnersDescription'),
      image: bookCover1,
      pdfPath: book1
    },
    {
      id: 2,
      title: t('books.investmentsAndTrading'),
      description: t('books.investmentsAndTradingDescription'),
      image: bookCover2,
      pdfPath: book2
    },
    {
      id: 3,
      title: t('books.onlineTrading'),
      description: t('books.onlineTradingDescription'),
      image: bookCover3,
      pdfPath: book3
    },
    {
      id: 4,
      title: t('books.strongestSignal'),
      description: t('books.strongestSignalDescription'),
      image: bookCover4,
      pdfPath: book4
    },
    {
      id: 5,
      title: t('books.dealsAndExecution'),
      description: t('books.dealsAndExecutionDescription'),
      image: bookCover5,
      pdfPath: book5
    },
    {
      id: 6,
      title: t('books.tradingErrors'),
      description: t('books.tradingErrorsDescription'),
      image: bookCover6,
      pdfPath: book6
    },
    {
      id: 7,
      title: t('books.riskManagement'),
      description: t('books.riskManagementDescription'),
      image: bookCover7,
      pdfPath: book7
    },
    // {
    //   id: 8,
    //   title: 'Фундаментальный анализ',
    //   description: 'Чтобы преуспеть в качестве трейдера, важно, чтобы вы провели подробный анализ рынка, прежде чем открывать какую-либо позицию. Фундаментальный анализ — это тип анализа рынка, который включает изучение экономических, социальных и политических факторов и их влияние на стоимость активов.',
    //   image: bookCover8,
    //   isLocked: true
    // },
    // {
    //   id: 9,
    //   title: 'Технический анализ',
    //   description: 'Чтобы преуспеть в качестве трейдера, важно провести подробный анализ рынка, прежде чем открывать какую-либо позицию. Технический анализ — это стратегия прогнозирования будущих движений рынка путем изучения исторических ценовых моделей и тенденций.',
    //   image: bookCover9,
    //   isLocked: true
    // },
    // {
    //   id: 10,
    //   title: 'Стратегии торговли',
    //   description: 'Эта электронная книга была создана с целью вооружить трейдеров необходимыми навыками для простого, быстрого и интерактивного изучения различных торговых стратегий, от базовых до более продвинутых и сложных.',
    //   image: bookCover10,
    //   isLocked: true
    // }
  ];

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const response = await fetch("https://api.maxprofitacademy.com/user", {
          method: "GET",
          headers: {
            "token": JSON.parse(token)
          }
        });

        const data = await response.json();
        if (data.status === 200) {
          setUserData(data.data);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  const hasValidCourse = userData?.course && ['GOLD', 'SILVER', 'PLATINUM'].includes(userData.course.toUpperCase());

  const handleViewPDF = (pdfPath) => {
    window.open(pdfPath, '_blank');
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
      {books.map((book) => {
        const isBookAvailable = !book.isLocked && hasValidCourse;
        
        return (
          <div key={book.id} className="bg-white rounded-3xl p-6 flex shadow-sm hover:shadow-md transition-shadow">
            <div className="md:w-1/3 w-20">
              <img 
                src={book.image} 
                alt={book.title} 
                className="w-full h-auto object-cover"
              />
            </div>
            
            <div className="w-2/3 pl-6 flex flex-col">
              <h3 className="md:text-xl text-sm font-semibold mb-2">{book.title}</h3>
              <p className="text-gray-600 md:text-sm text-xs flex-grow">{book.description}</p>
              
              {isBookAvailable ? (
                <button 
                  onClick={() => handleViewPDF(book.pdfPath)}
                  className="mt-4 flex items-center text-[12px] md:text-[18px] justify-center space-x-2 bg-primary text-black px-4 py-2 rounded-xl hover:bg-primary/90 transition-colors"
                >
                  <BookOpenIcon className="w-5 h-5" />
                  <span>{t('books.read')}</span>
                </button>
              ) : (
                <button 
                  className="mt-4 flex items-center text-[12px] md:text-[18px] justify-center space-x-2 bg-gray-100 text-gray-500 px-4 py-2 rounded-xl hover:bg-gray-200 transition-colors"
                  disabled
                >
                  <LockClosedIcon className="w-5 h-5" />
                  <span>{t('books.unavailable')}</span>
                </button>
              )}
            </div>
          </div>
        );
      })}

      <BottomNav />
    </div>
  );
}

export default Books; 